export const systemAuditConstants = {
    
    GET_ALL_SYSTEM_AUDIT_REQUEST: "GET_ALL_SYSTEM_AUDIT_REQUEST",
    GET_ALL_SYSTEM_AUDIT_SUCCESS: "GET_ALL_SYSTEM_AUDIT_SUCCESS",
    GET_ALL_SYSTEM_AUDIT_FAILURE: "GET_ALL_SYSTEM_AUDIT_FAILURE",

    SYSTEM_AUDIT_TOP_CARD_REQUEST: "SYSTEM_AUDIT_TOP_CARD_REQUEST",
    SYSTEM_AUDIT_TOP_CARD_SUCCESS: "SYSTEM_AUDIT_TOP_CARD_SUCCESS",
    SYSTEM_AUDIT_TOP_CARD_FAILURE: "SYSTEM_AUDIT_TOP_CARD_FAILURE",

    GET_ALL_SYSTEM_AUDIT_FILTERS_REQUEST: "GET_ALL_SYSTEM_AUDIT_FILTERS_REQUEST",
    GET_ALL_SYSTEM_AUDIT_FILTERS_SUCCESS: "GET_ALL_SYSTEM_AUDIT_FILTERS_SUCCESS",
    GET_ALL_SYSTEM_AUDIT_FILTERS_FAILURE: "GET_ALL_SYSTEM_AUDIT_FILTERS_FAILURE",

}